import { isValidInput as validateInput } from '../../../utils';
import regexExpressions from '@/constants/regexExpressions';

export const isRequired = (value?: string | string[]) =>
  !!value?.length || 'Required';
export const isValidInput = (value?: string) =>
  validateInput(value?.trim() || '') || 'Invalid input';
export const isOptionRequired = (value?: boolean) =>
  value !== undefined || 'Please select an option';

export const createRequiredValidator =
  (message: string) => (value?: string | string[]) =>
    !!value?.length || message;
export const createMinLengthValidator =
  (minLength: number, optional = false) =>
  (value?: string) =>
    (optional && !value) ||
    (value?.length ?? 0) >= minLength ||
    `Minimum ${minLength} chars`;
export const createMaxLengthValidator =
  (maxLength: number, optional = false) =>
  (value?: string) =>
    (optional && !value) ||
    (value?.length ?? 0) <= maxLength ||
    `Maximum ${maxLength} chars are allowed`;

export const createUrlValidator =
  (message = 'Please enter a valid URL') =>
  (value?: string) => {
    const pattern = new RegExp(regexExpressions.url);
    return !value || pattern.test(value) || message;
  };

export const createWebsiteValidator =
  (
    message = 'Please enter a valid website URL with https protocol',
    optional = false
  ) =>
  (value?: string) =>
    (optional && !value) ||
    regexExpressions.website.test(value ?? '') ||
    message;

export const createEmailValidator =
  (message = 'Please enter a valid email address') =>
  (value?: string) =>
    regexExpressions.email.test(value ?? '') || message;
